import React, { Component } from "react";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
export default class Snackbar1 extends Component {
  render() {
    return (
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        open={this.props.open}
        autoHideDuration={2000}
        onClose={() => {
          this.props.close_snack_bar();
        }}
        ContentProps={{
          "aria-describedby": "message-id",
        }}
        message={<span id="message-id">{this.props.message}</span>}
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            onClick={() => {
              this.props.close_snack_bar();
            }}
          >
            <CancelRoundedIcon />
          </IconButton>,
        ]}
      />
    );
  }
}